import { api } from "../lib/api";

export async function fetchUsers(departmentId) {
  const qs = departmentId != null ? `?department_id=${departmentId}` : "";
  return api.get(`/api/users${qs}`);
}

export async function createUser(payload) {
  return api.post("/api/users", payload);
}

export async function updateUser(userId, fields) {
  return api.patch(`/api/users/${userId}`, fields);
}

export async function fetchMemberships(userId) {
  return api.get(`/api/users/${userId}/memberships`);
}

export async function setMembership(userId, departmentId, role) {
  return api.post(`/api/users/${userId}/memberships`, { department_id: departmentId, role });
}

export async function removeMembership(userId, departmentId) {
  return api.del(`/api/users/${userId}/memberships/${departmentId}`);
}

export async function fetchDepartments() {
  return api.get("/api/departments");
}

export async function createDepartment(code, name) {
  return api.post("/api/departments", { code, name });
}

export async function updateDepartment(deptId, fields) {
  return api.patch(`/api/departments/${deptId}`, fields);
}
